// @flow
import { Linking, Platform } from 'react-native';
import InAppBrowser from 'react-native-inappbrowser-reborn';
import HandleErrorService from '../lib/handleError';
import config from '../config';
import RNFS from 'react-native-fs';
import FileViewer from 'react-native-file-viewer';
import WizzeeLog from './wizzeeLog';

export const openInInternalBrowser = (url: string, onClose?: () => void) => {
  if (Platform.OS === 'ios' || Platform.OS === 'android') {
    return InAppBrowser.isAvailable()
      .then(() => InAppBrowser.open(url))
      .then(result => {
        if (onClose && result.type === 'cancel') {
          onClose();
        }
      })
      .catch(error => {
        WizzeeLog.error(error);
        openInExternalBrowser(url);
      });
  } else {
    return openInExternalBrowser(url);
  }
};

export const openInExternalBrowser = (url: string) =>
  Linking.canOpenURL(url)
    .then(() => Linking.openURL(url))
    .catch(HandleErrorService.showToastError);

export const openWebLinkInNewTab = (url: string) => window.open(url, '_blank');

export const openUrl = (url: string) => {
  if (Platform.OS === 'web') {
    openWebLinkInNewTab(url);
  } else {
    openInInternalBrowser(url);
  }
};

export const openFileByFileOuid = async (
  fileNameWithExtension: string,
  fileOuid: string,
  token: string | null,
  convertToPdf: boolean = false
) => {
  if (!token) {
    return null;
  }

  let url = config.TRPC_FILE_URL.replace('{fileOuid}', fileOuid);
  if (convertToPdf) {
    url = `${url}?convertToPdf=true`;
  }

  if (Platform.OS === 'web') {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: token,
          Pragma: 'no-jwt-cookie',
        },
      });
      const blob = await response.blob();
      const fileURL = URL.createObjectURL(blob);
      openWebLinkInNewTab(fileURL);
    } catch (error) {
      HandleErrorService.showToastError(error);
    }
    return;
  }

  try {
    const localFilePath = `${RNFS.DocumentDirectoryPath}/${fileNameWithExtension}`;
    const { promise: downloadPromise } = RNFS.downloadFile({
      fromUrl: url,
      toFile: localFilePath,
      headers: {
        Authorization: token,
        Pragma: 'no-jwt-cookie',
      },
    });
    const response = await downloadPromise;
    if (response.statusCode !== 200) {
      throw new Error(`SERVER_ERROR_${response.statusCode}`);
    }

    await FileViewer.open(localFilePath, { showOpenWithDialog: true });
  } catch (error) {
    HandleErrorService.showToastError(error);
  }
};

export const openStaticFileByFileName = (fileName: string) => {
  const url = config.STATIC_FILE_URL.replace('{fileName}', fileName);

  openUrl(url);
};
